module.exports = __webpack_public_path__ + "static/media/maquiagem.12185bcd.jpg";